import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, Link } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = require('react-router-dom').useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const COLORS = {
    black: '#000000',
    white: '#FFFFFF',
    gray: '#333333',
    lightGray: '#CCCCCC',
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#fff',
      color: '#000',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');

        * { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        ::selection { background: ${COLORS.black}; color: ${COLORS.white}; }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }

        @keyframes bangGlitch {
          0%, 100% { text-shadow: 2px 0 #000, -2px 0 #000; }
          20% { text-shadow: -3px 2px #000, 3px -1px rgba(0,0,0,0.3); }
          40% { text-shadow: 3px -2px #000, -2px 3px rgba(0,0,0,0.3); }
          60% { text-shadow: -2px -2px #000, 2px 2px rgba(0,0,0,0.3); }
          80% { text-shadow: 2px 3px #000, -3px -2px rgba(0,0,0,0.3); }
        }


        .bang-button {
          position: relative;
          display: inline-block;
          font-family: 'Special Elite', 'Courier New', monospace;
          font-size: clamp(4rem, 12vw, 10rem);
          color: #000;
          cursor: pointer;
          letter-spacing: 0.05em;
          animation: bangGlitch 4s steps(1) infinite;
          transition: transform 0.2s ease, letter-spacing 0.3s ease;
          user-select: none;
          -webkit-user-select: none;
          background: none;
          border: none;
          padding: 1rem 2rem;
          outline: none;
          line-height: 1;
        }


        .bang-button:hover {
          transform: scale(1.15);
          letter-spacing: 0.15em;
          animation: none;
          text-shadow:
            0 0 20px rgba(0,0,0,0.3),
            0 0 40px rgba(0,0,0,0.15),
            0 0 60px rgba(0,0,0,0.05);
        }


        .bang-button:active {
          transform: scale(1.3);
          text-shadow:
            0 0 40px rgba(0,0,0,0.5),
            0 0 80px rgba(0,0,0,0.3),
            0 0 120px rgba(0,0,0,0.1);
        }

        .dialogue-line {
          opacity: 0;
          animation: fadeIn 0.6s ease forwards;
        }

        .legal-content {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          line-height: 1.8;
          color: rgba(0,0,0,0.9);
        }
        .legal-content h2 {
          font-family: 'Special Elite', 'Courier New', monospace;
          font-size: 1.5rem;
          margin-top: 3rem;
          margin-bottom: 1rem;
          color: ${COLORS.black};
          letter-spacing: 0.05em;
        }
        .legal-content h3 { font-size: 1.2rem; margin-top: 2rem; margin-bottom: 0.5rem; color: #000; }
        .legal-content h4 { font-size: 1.1rem; margin-top: 1.5rem; margin-bottom: 0.5rem; color: rgba(0,0,0,0.9); }
        .legal-content p { margin-bottom: 1rem; color: rgba(0,0,0,0.8); }
        .legal-content ul, .legal-content ol { margin-bottom: 1rem; padding-left: 1.5rem; color: rgba(0,0,0,0.8); }
        .legal-content li { margin-bottom: 0.5rem; }
        .legal-content a { color: ${COLORS.black}; text-decoration: underline; }

        .footer-link { color: rgba(0,0,0,0.6); text-decoration: none; font-size: 0.9rem; transition: color 0.3s; }
        .footer-link:hover { color: #000; }
        .nav-link { color: rgba(0,0,0,0.7); text-decoration: none; font-family: 'Special Elite', 'Courier New', monospace; font-size: 1rem; transition: color 0.3s; cursor: pointer; }
        .nav-link:hover { color: #000; }

        .hamburger { display: none; background: none; border: none; cursor: pointer; padding: 0.5rem; }
        .hamburger span { display: block; width: 24px; height: 2px; background: #000; margin: 5px 0; transition: all 0.3s; }
        .nav-desktop { display: flex; gap: 2rem; align-items: center; }
        .nav-mobile-overlay { display: none; }

        @media (max-width: 768px) {
          .home-main { padding-left: 0.5rem !important; padding-right: 0.5rem !important; }
          .home-dialogue { padding: 2rem 0.25rem !important; }
          .hamburger { display: block; }
          .nav-desktop { display: none; }
          .nav-mobile-overlay {
            display: flex;
            position: fixed; top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(255,255,255,0.98);
            flex-direction: column; justify-content: center; align-items: center;
            gap: 2rem; z-index: 1500;
          }
          .nav-mobile-overlay .nav-link { font-size: 1.5rem; }
        }

        .app-card { transition: all 0.3s ease; }
        .app-card:hover { background: ${COLORS.black} !important; color: ${COLORS.white}; transform: scale(1.02); }
        .app-card:hover * { color: ${COLORS.white} !important; }

        .video-modal { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.98); display: flex; justify-content: center; align-items: center; z-index: 2000; }
        .video-modal-close { position: absolute; top: 2rem; right: 2rem; background: none; border: 2px solid black; color: black; font-size: 1.5rem; width: 50px; height: 50px; cursor: pointer; font-family: 'Special Elite', monospace; transition: all 0.3s ease; }
        .video-modal-close:hover { background: black; color: white; }
      `}</style>

      {showVideo && (
        <div className="video-modal" onClick={() => setShowVideo(false)}>
          <button className="video-modal-close" onClick={() => setShowVideo(false)}>✕</button>
          <div style={{ width: '80%', maxWidth: '900px', aspectRatio: '16/9' }} onClick={(e) => e.stopPropagation()}>
            <iframe
              src="https://www.youtube.com/embed/Umc9ezAyJv0?rel=0"
              title="Voight-Kampff Test - Blade Runner"
              style={{ width: '100%', height: '100%', border: 'none' }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}

      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#fff', zIndex: 0 }} />

      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        padding: '1.5rem 3rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        zIndex: 100, background: 'linear-gradient(to bottom, rgba(255,255,255,0.95), transparent)'
      }}>
        <div
          style={{ width: '40px', height: '40px', backgroundColor: COLORS.black, cursor: 'pointer' }}
          onClick={() => navigate('/')}
        />
        <nav className="nav-desktop">
          <Link to="/" className="nav-link">HOME</Link>
          <Link to="/apps" className="nav-link">APPS</Link>
          <a className="nav-link" onClick={() => setShowVideo(true)}>VIDEO</a>
        </nav>

        <button className="hamburger" onClick={() => setMenuOpen(true)}>
          <span /><span /><span />
        </button>
      </header>

      {menuOpen && (
        <div className="nav-mobile-overlay">
          <button onClick={() => setMenuOpen(false)} style={{
            position: 'absolute', top: '1.5rem', right: '3rem',
            background: 'none', border: '2px solid black', color: 'black',
            fontSize: '1.5rem', width: '50px', height: '50px', cursor: 'pointer',
            fontFamily: "'Special Elite', monospace"
          }}>✕</button>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>HOME</Link>
          <Link to="/apps" className="nav-link" onClick={() => setMenuOpen(false)}>APPS</Link>
          <a className="nav-link" onClick={() => { setShowVideo(true); setMenuOpen(false); }}>VIDEO</a>
        </div>
      )}

      {React.cloneElement(children, { setShowVideo })}

      <footer style={{
        position: 'relative', zIndex: 10, padding: '3rem', textAlign: 'center',
        borderTop: `1px solid ${COLORS.lightGray}`, background: COLORS.white
      }}>
        <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
          <Link to="/support" className="footer-link">Support</Link>
          <Link to="/privacy" className="footer-link">Privacy</Link>
          <Link to="/terms" className="footer-link">Terms</Link>
          <Link to="/legal" className="footer-link">Legal</Link>
          <Link to="/account-deletion" className="footer-link">Delete Account</Link>
        </div>
        <p style={{
          fontFamily: "'Special Elite', 'Courier New', monospace",
          fontSize: '0.9rem', letterSpacing: '0.1em', opacity: 0.5, color: '#000'
        }}>
          © 2026 VOIGHT-KAMPFF SARL — "MORE HUMAN THAN HUMAN"
        </p>
      </footer>
    </div>
  );
};

const dialogueLines = [
  { speaker: 'LEON', text: "IS IT OKAY IF I TALK? I GET KIND OF NERVOUS WHEN I TAKE TESTS." },
  { speaker: 'HOLDEN', text: "JUST PLEASE DON'T MOVE." },
  { speaker: 'LEON', text: "SORRY. I ALREADY HAD AN IQ TEST THIS YEAR. I DON'T THINK I'VE EVER HAD..." },
  { speaker: 'HOLDEN', text: "REACTION TIME IS A FACTOR IN THIS, SO PLEASE PAY ATTENTION. NOW ANSWER AS QUICKLY AS YOU CAN." },
  { speaker: 'HOLDEN', text: "1187 AT HUNTERWASSER." },
  { speaker: 'LEON', text: "THAT'S THE HOTEL." },
  { speaker: 'HOLDEN', text: "WHAT?" },
  { speaker: 'LEON', text: "WHERE I LIVE." },
  { speaker: 'HOLDEN', text: "NICE PLACE?" },
  { speaker: 'LEON', text: "YEAH, SURE. I GUESS. THAT PART OF THE TEST?" },
  { speaker: 'HOLDEN', text: "NO, JUST WARMING YOU UP, THAT'S ALL." },
  { speaker: 'LEON', text: "IT'S NOT FANCY OR ANYTHING." },
  { speaker: 'HOLDEN', text: "YOU'RE IN A DESERT, WALKING ALONG IN THE SAND, WHEN ALL OF A SUDDEN..." },
  { speaker: 'LEON', text: "IS THIS THE TEST NOW?" },
  { speaker: 'HOLDEN', text: "YES. YOU'RE IN A DESERT, WALKING ALONG IN THE SAND, WHEN ALL OF A SUDDEN YOU LOOK DOWN..." },
  { speaker: 'LEON', text: "WHAT DESERT?" },
  { speaker: 'HOLDEN', text: "IT DOESN'T MAKE ANY DIFFERENCE WHAT DESERT. IT'S COMPLETELY HYPOTHETICAL." },
  { speaker: 'LEON', text: "BUT HOW COME I'D BE THERE?" },
  { speaker: 'HOLDEN', text: "MAYBE YOU'RE FED UP. MAYBE YOU WANT TO BE BY YOURSELF. WHO KNOWS." },
  { speaker: 'HOLDEN', text: "YOU LOOK DOWN AND YOU SEE A TORTOISE, LEON. IT'S CRAWLING TOWARDS YOU." },
  { speaker: 'LEON', text: "TORTOISE? WHAT'S THAT?" },
  { speaker: 'HOLDEN', text: "YOU KNOW WHAT A TURTLE IS?" },
  { speaker: 'LEON', text: "OF COURSE." },
  { speaker: 'HOLDEN', text: "SAME THING." },
  { speaker: 'LEON', text: "NEVER SEEN A TURTLE. BUT I UNDERSTAND WHAT YOU MEAN." },
  { speaker: 'HOLDEN', text: "YOU REACH DOWN. YOU FLIP THE TORTOISE OVER ON ITS BACK, LEON." },
  { speaker: 'LEON', text: "DO YOU MAKE UP THESE QUESTIONS, MR. HOLDEN, OR DO THEY WRITE THEM DOWN FOR YOU?" },
  { speaker: 'HOLDEN', text: "THE TORTOISE LAYS ON ITS BACK, ITS BELLY BAKING IN THE HOT SUN, BEATING ITS LEGS, TRYING TO TURN ITSELF OVER, BUT IT CAN'T. NOT WITHOUT YOUR HELP. BUT YOU'RE NOT HELPING." },
  { speaker: 'LEON', text: "WHAT DO YOU MEAN I'M NOT HELPING?" },
  { speaker: 'HOLDEN', text: "I MEAN, YOU'RE NOT HELPING. WHY IS THAT, LEON?" },
  { speaker: 'HOLDEN', text: "THEY'RE JUST QUESTIONS, LEON. IN ANSWER TO YOUR QUERY, THEY'RE WRITTEN DOWN FOR ME. IT'S A TEST, DESIGNED TO PROVOKE AN EMOTIONAL RESPONSE. SHALL WE CONTINUE?" },
  { speaker: 'HOLDEN', text: "DESCRIBE IN SINGLE WORDS ONLY THE GOOD THINGS THAT COME INTO YOUR MIND ABOUT YOUR MOTHER." },
  { speaker: 'LEON', text: "MY MOTHER?" },
  { speaker: 'HOLDEN', text: "YEAH." },
  { speaker: 'LEON', text: "LET ME TELL YOU ABOUT MY MOTHER." },
];

const apps = [
  { name: 'FOLD', description: 'Real personalized news', status: 'AVAILABLE' },
  { name: 'MICHELLE', description: 'The social cookbook', status: 'AVAILABLE' },
  { name: 'STICKYT', description: 'Quick note taker', status: 'AVAILABLE' },
  { name: 'AICHAT', description: 'The omni-bubble you need', status: 'AVAILABLE' },
  { name: 'HANDSNAP', description: 'Selfies from a distance', status: 'AVAILABLE' },
  { name: 'SHELF', description: 'Capture on iPhone, watch on TV', status: 'AVAILABLE' },
  { name: 'HANGAR', description: 'Help you ship Apple apps', status: 'AVAILABLE' },
  { name: 'PARTNERSHIP', description: 'Manage partnerships', status: 'AVAILABLE' },
  { name: 'SLACKDIGEST', description: 'Your daily dose of Slack', status: 'AVAILABLE' },
  { name: 'PAYEMESHEURES', description: 'Help people claim unpaid work', status: 'AVAILABLE' },
  { name: 'NEXTTRAIN', description: 'The next train to go to work or home', status: 'AVAILABLE' },
  { name: 'PALMANAGER', description: 'Rails to build Pal Company', status: 'AVAILABLE' },
];

const appsWithPages = [
  { slug: 'fold', name: 'FOLD', description: 'Real personalized news' },
  { slug: 'michelle', name: 'MICHELLE', description: 'The social cookbook' },
  { slug: 'stickyt', name: 'STICKYT', description: 'Quick note taker' },
  { slug: 'aichat', name: 'AICHAT', description: 'The omni-bubble you need' },
  { slug: 'handsnap', name: 'HANDSNAP', description: 'Selfies from a distance' },
  { slug: 'shelf', name: 'SHELF', description: 'Capture on iPhone, watch on TV' },
  { slug: 'hangar', name: 'HANGAR', description: 'Help you ship Apple apps' },
  { slug: 'partnership', name: 'PARTNERSHIP', description: 'Manage partnerships' },
  { slug: 'slackdigest', name: 'SLACKDIGEST', description: 'Your daily dose of Slack' },
  { slug: 'nexttrain', name: 'NEXTTRAIN', description: 'The next train to go to work or home' },
];

const Home = ({ setShowVideo }) => (
  <main className="home-main" style={{
    position: 'relative', zIndex: 10, minHeight: '100vh',
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    padding: '8rem 1rem'
  }}>
    <div className="home-dialogue" style={{ maxWidth: '1200px', width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem', padding: '4rem 1rem' }}>
      {dialogueLines.map((line, index) => (
        <div key={index} className="dialogue-line" style={{
          display: 'flex', justifyContent: line.speaker === 'LEON' ? 'flex-end' : 'flex-start',
          animationDelay: `${index * 0.15}s`
        }}>
          <div style={{ maxWidth: '80%', textAlign: line.speaker === 'LEON' ? 'right' : 'left' }}>
            <div style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: 'clamp(0.7rem, 1.5vw, 0.9rem)', color: '#000', opacity: 0.5, marginBottom: '0.2rem', letterSpacing: '0.1em' }}>
              {line.speaker}
            </div>
            <span style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: 'clamp(1rem, 3vw, 2rem)', color: '#000' }}>
              {line.text}
            </span>
          </div>
        </div>
      ))}
    </div>

    <div style={{ marginTop: '4rem', textAlign: 'center', position: 'relative' }}>
      <button className="bang-button" onClick={() => setShowVideo(true)}>
        BANG
      </button>
    </div>

    <section id="about" style={{ marginTop: '8rem', textAlign: 'center', maxWidth: '800px' }}>
      <h2 style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: 'clamp(1.5rem, 4vw, 3rem)', marginBottom: '2rem', color: '#000' }}>
        AI SINCE 2010
      </h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 2, opacity: 0.7, fontFamily: "'Special Elite', 'Courier New', monospace", letterSpacing: '0.02em', color: '#000' }}>
        VOIGHT-KAMPFF DEVELOPS INNOVATIVE APPLICATIONS<br />USING ARTIFICIAL INTELLIGENCE.<br /><br />
        OUR NAME COMES FROM THE EMPATHY TEST IN BLADE RUNNER,<br />SYMBOLIZING OUR EXPLORATION OF THE BOUNDARY<br />BETWEEN HUMAN AND MACHINE.
      </p>
    </section>
  </main>
);

const Apps = () => (
  <main style={{ position: 'relative', zIndex: 10, minHeight: '100vh', padding: '8rem 2rem', maxWidth: '1000px', margin: '0 auto' }}>
    <h1 style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '2.5rem', marginBottom: '1rem', color: '#000' }}>APPLICATIONS</h1>
    <p style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '1rem', marginBottom: '3rem', opacity: 0.6, color: '#000' }}>iOS apps crafted with AI</p>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', width: '100%' }}>
      {apps.map((app, i) => (
        <div key={i} className="app-card" style={{ background: '#fff', border: '2px solid #000', padding: '2.5rem 2rem', cursor: 'pointer', transition: 'all 0.3s ease' }}>
          <div style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '1.8rem', letterSpacing: '0.05em', marginBottom: '0.5rem', color: '#000' }}>{app.name}</div>
          <div style={{ fontSize: '0.95rem', opacity: 0.6, marginBottom: '1.5rem', color: '#000' }}>{app.description}</div>
          <div style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '0.8rem', letterSpacing: '0.2em', opacity: 0.4, color: '#000' }}>{app.status}</div>
        </div>
      ))}
    </div>
  </main>
);

const LegalPage = ({ title, children }) => (
  <main style={{ position: 'relative', zIndex: 10, minHeight: '100vh', padding: '8rem 2rem', maxWidth: '900px', margin: '0 auto' }}>
    <h1 style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '2rem', marginBottom: '3rem', color: '#000' }}>{title}</h1>
    <div className="legal-content">{children}</div>
  </main>
);

const Privacy = () => (
  <LegalPage title="PRIVACY POLICY">
    <p><strong>Last updated:</strong> February 2026</p>
    <p>VOIGHT-KAMPFF (hereinafter "we", "our" or "VOIGHT-KAMPFF") places great importance on protecting your personal data. This privacy policy describes how we collect, use, store and protect your information when you use our mobile applications and services.</p>

    <h2>1. DATA CONTROLLER</h2>
    <p>VOIGHT-KAMPFF<br />SARL with capital of €100<br />49 rue Charles Infroit<br />94500 Champigny-sur-Marne, France<br />SIRET: 823 547 526 00025<br />Email: privacy@voight-kampff.app</p>

    <h2>2. DATA COLLECTED</h2>
    <p>We collect the following categories of data:</p>
    <h3>2.1 Identification data</h3>
    <ul><li>Email address</li><li>Username</li><li>Password (encrypted)</li></ul>
    <h3>2.2 Location data</h3>
    <ul><li>Geographic location (if you authorize it)</li><li>Country and timezone</li></ul>
    <h3>2.3 Usage and analytics data</h3>
    <ul><li>App interactions</li><li>Features used</li><li>Performance and crash data</li><li>Device type and operating system</li></ul>

    <h2>3. PURPOSE OF PROCESSING</h2>
    <p>Your data is used to:</p>
    <ul><li>Create and manage your user account</li><li>Provide and improve our services</li><li>Personalize your experience</li><li>Send you important notifications</li><li>Analyze usage of our applications</li><li>Ensure security of our services</li><li>Comply with our legal obligations</li></ul>

    <h2>4. LEGAL BASIS</h2>
    <p>Processing of your data is based on:</p>
    <ul><li><strong>Contract performance</strong>: to provide our services</li><li><strong>Your consent</strong>: for geolocation and marketing communications</li><li><strong>Legitimate interest</strong>: to improve our services and ensure security</li><li><strong>Legal obligations</strong>: to meet regulatory requirements</li></ul>

    <h2>5. DATA SHARING</h2>
    <p>Your data may be shared with:</p>
    <ul><li><strong>Technical providers</strong>: hosting (Vercel Inc., USA), analytics</li><li><strong>Apple</strong>: for in-app purchases and distribution</li><li><strong>Authorities</strong>: if required by law</li></ul>
    <p>We never sell your personal data to third parties.</p>

    <h2>6. RETENTION PERIOD</h2>
    <ul><li><strong>Account data</strong>: until account deletion + 1 year</li><li><strong>Analytics data</strong>: 26 months maximum</li><li><strong>Billing data</strong>: 10 years (legal requirement)</li></ul>

    <h2>7. YOUR RIGHTS</h2>
    <p>Under GDPR, you have the following rights:</p>
    <ul><li><strong>Access</strong>: obtain a copy of your data</li><li><strong>Rectification</strong>: correct inaccurate data</li><li><strong>Erasure</strong>: request deletion of your data</li><li><strong>Restriction</strong>: restrict processing</li><li><strong>Portability</strong>: receive your data in a structured format</li><li><strong>Objection</strong>: object to processing</li><li><strong>Withdraw consent</strong>: at any time</li></ul>
    <p>To exercise these rights: <strong>privacy@voight-kampff.app</strong></p>

    <h2>8. ACCOUNT DELETION</h2>
    <p>You can request deletion of your account and all associated data:</p>
    <ul><li><strong>In the app</strong>: Settings → Account → Delete my account</li><li><strong>By email</strong>: privacy@voight-kampff.app with subject "Account deletion"</li><li><strong>Online</strong>: <Link to="/account-deletion" style={{color: '#000'}}>Account Deletion Page</Link></li></ul>
    <p>Deletion will be effective within 30 days. Some data may be retained for legal obligations.</p>

    <h2>9. SECURITY</h2>
    <p>We implement appropriate technical and organizational measures:</p>
    <ul><li>Encryption of data in transit (TLS) and at rest</li><li>Secure authentication</li><li>Restricted access to data</li><li>Regular monitoring and audits</li></ul>

    <h2>10. INTERNATIONAL TRANSFERS</h2>
    <p>Your data is hosted by Vercel Inc. (USA). For transfers outside the EU, we ensure appropriate safeguards (standard contractual clauses, adequacy decision).</p>

    <h2>11. MINORS</h2>
    <p>Our applications are not intended for children under 16 years of age. We do not knowingly collect data from minors.</p>

    <h2>12. CHANGES</h2>
    <p>This policy may be updated. Significant changes will be notified to you by email or in the application.</p>

    <h2>13. ADVERTISING & TRACKING</h2>
    <p>Our applications do <strong>not</strong> use advertising tracking technologies. We do not collect or use the Apple Identifier for Advertisers (IDFA). We do not track users across third-party apps or websites. Our applications do not display third-party advertisements.</p>

    <h2>14. APPLE APP PRIVACY DETAILS</h2>
    <p>In accordance with Apple's App Store requirements, here is a summary of our data practices:</p>
    <h3>Data Used to Track You</h3>
    <p>None. We do not track you across apps or websites owned by other companies.</p>
    <h3>Data Linked to You</h3>
    <ul><li><strong>Contact Info</strong>: email address</li><li><strong>Identifiers</strong>: username, user ID</li><li><strong>Usage Data</strong>: product interaction, features used</li></ul>
    <h3>Data Not Linked to You</h3>
    <ul><li><strong>Diagnostics</strong>: crash data, performance data</li></ul>

    <h2>15. CONTACT & COMPLAINTS</h2>
    <p>For any questions: <strong>privacy@voight-kampff.app</strong><br /><br />You may also file a complaint with the CNIL:<br />Commission Nationale de l'Informatique et des Libertés<br />3 Place de Fontenoy, TSA 80715<br />75334 Paris Cedex 07<br />www.cnil.fr</p>

    <h2>16. APP-SPECIFIC PRIVACY POLICIES</h2>
    <ul>
      {appsWithPages.map(app => (
        <li key={app.slug}><Link to={`/privacy/${app.slug}`} style={{color: '#000'}}>{app.name} Privacy Policy</Link></li>
      ))}
    </ul>
  </LegalPage>
);

const Terms = () => (
  <LegalPage title="TERMS OF USE">
    <p><strong>Last updated:</strong> February 2026</p>

    <h2>1. PURPOSE</h2>
    <p>These Terms of Use govern the use of mobile applications published by VOIGHT-KAMPFF. By downloading or using our applications, you accept these terms.</p>

    <h2>2. PUBLISHER</h2>
    <p>VOIGHT-KAMPFF<br />SARL with capital of €100<br />RCS Créteil 823 547 526<br />49 rue Charles Infroit<br />94500 Champigny-sur-Marne, France<br />Email: contact@voight-kampff.app</p>

    <h2>3. ACCESS TO SERVICE</h2>
    <h3>3.1 Registration</h3>
    <p>Some features require account creation. You agree to:</p>
    <ul><li>Provide accurate and up-to-date information</li><li>Maintain confidentiality of your credentials</li><li>Notify us of any unauthorized use</li></ul>
    <h3>3.2 Age requirements</h3>
    <p>You must be at least 16 years old to use our services. If you are between 16 and 18, you declare that you have parental or guardian authorization.</p>

    <h2>4. USE OF SERVICE</h2>
    <h3>4.1 License</h3>
    <p>We grant you a limited, non-exclusive, non-transferable and revocable license to use our applications for personal and non-commercial purposes.</p>
    <h3>4.2 Prohibited conduct</h3>
    <p>It is forbidden to:</p>
    <ul><li>Use the service illegally or fraudulently</li><li>Attempt to bypass security measures</li><li>Decompile, disassemble or reverse engineer</li><li>Copy, modify or distribute content without authorization</li><li>Use robots, scripts or automated tools</li><li>Harass, threaten or harm other users</li><li>Publish illegal, offensive or inappropriate content</li></ul>

    <h2>5. INTELLECTUAL PROPERTY</h2>
    <p>All application elements (code, design, texts, logos, images) are the exclusive property of VOIGHT-KAMPFF or its licensors. They are protected by French and international intellectual property laws.</p>
    <p>The "VOIGHT-KAMPFF" trademark and associated logo are registered trademarks.</p>

    <h2>6. USER CONTENT</h2>
    <p>If our applications allow you to create content:</p>
    <ul><li>You retain your rights to your content</li><li>You grant us a worldwide, free, non-exclusive license to use this content within the service</li><li>You are responsible for your content and guarantee it does not violate third-party rights</li></ul>

    <h2>7. IN-APP PURCHASES</h2>
    <p>Purchases made in the application are processed by Apple via the App Store. By making a purchase:</p>
    <ul><li>You accept Apple Media Services terms</li><li>Payment is collected by Apple</li><li>Refund requests must be addressed to Apple</li></ul>
    <h3>7.1 Subscriptions</h3>
    <p>If applicable:</p>
    <ul><li>Subscriptions renew automatically</li><li>You can disable renewal in your Apple account settings at least 24h before the end of the current period</li><li>No pro-rata refund is made upon cancellation</li></ul>

    <h2>8. SERVICE AVAILABILITY</h2>
    <p>We strive to ensure service availability but do not guarantee uninterrupted access. Interruptions may occur for maintenance, updates or force majeure.</p>

    <h2>9. LIMITATION OF LIABILITY</h2>
    <p>To the extent permitted by law:</p>
    <ul><li>The service is provided "as is"</li><li>We do not guarantee absence of errors or bugs</li><li>We are not liable for indirect damages</li><li>Our liability is limited to amounts paid by you in the last 12 months</li></ul>

    <h2>10. SUSPENSION AND TERMINATION</h2>
    <p>We may suspend or terminate your access in case of:</p>
    <ul><li>Violation of these Terms</li><li>Conduct harmful to other users or the service</li><li>Request from a competent authority</li></ul>
    <p>You may terminate your account at any time (see <Link to="/account-deletion" style={{color: '#000'}}>"Account deletion"</Link>).</p>

    <h2>11. CHANGES</h2>
    <p>We may modify these Terms at any time. Changes take effect upon publication. Continued use of the service after modification constitutes acceptance.</p>

    <h2>12. GOVERNING LAW AND DISPUTES</h2>
    <p>These Terms are governed by French law.</p>
    <p>In case of dispute, an amicable solution will be sought. Failing that, the courts of Créteil shall have exclusive jurisdiction.</p>
    <p>For European consumers: you may use the European Commission's Online Dispute Resolution platform: https://ec.europa.eu/consumers/odr</p>

    <h2>13. CONTACT</h2>
    <p>For any questions regarding these Terms: <strong>contact@voight-kampff.app</strong></p>
  </LegalPage>
);

const Legal = () => (
  <LegalPage title="LEGAL NOTICE">
    <h2>1. SITE PUBLISHER</h2>
    <p>
      <strong>VOIGHT-KAMPFF</strong><br />
      Limited Liability Company (SARL)<br />
      Share capital: €100<br /><br />
      <strong>Registered office:</strong><br />
      49 rue Charles Infroit<br />
      94500 Champigny-sur-Marne, France<br /><br />
      <strong>Registration:</strong><br />
      RCS Créteil 823 547 526<br />
      SIRET: 823 547 526 00025<br />
      APE/NAF Code: 6201Z (Computer programming)<br />
      VAT: FR 82 823547526<br />
      D-U-N-S: 268326669<br /><br />
      <strong>Publication Director:</strong><br />
      Arthur DAGARD, Manager<br /><br />
      <strong>Contact:</strong><br />
      Email: contact@voight-kampff.app
    </p>

    <h2>2. HOSTING</h2>
    <p><strong>Vercel Inc.</strong><br />340 S Lemon Ave #4133<br />Walnut, CA 91789<br />United States<br /><br />Website: www.vercel.com</p>

    <h2>3. INTELLECTUAL PROPERTY</h2>
    <p>All content on this site (texts, images, logos, graphics, icons, software, etc.) is the exclusive property of VOIGHT-KAMPFF or its partners and is protected by French and international intellectual property laws.</p>
    <p>Any reproduction, representation, modification, publication, adaptation of all or part of the site elements, by any means or process, is prohibited without prior written authorization from VOIGHT-KAMPFF.</p>
    <p>The name "VOIGHT-KAMPFF" refers to the fictional test from the film "Blade Runner" (1982) by Ridley Scott, based on Philip K. Dick's novel. This use is made as a cultural reference and does not imply any affiliation with the film's rights holders.</p>

    <h2>4. PERSONAL DATA</h2>
    <p>For information regarding the processing of your personal data, please consult our <Link to="/privacy" style={{color: '#000'}}>Privacy Policy</Link>.</p>
    <p>In accordance with the "Informatique et Libertés" law of January 6, 1978 and the General Data Protection Regulation (GDPR), you have rights of access, rectification and deletion of data concerning you.<br /><br />DPO Contact: privacy@voight-kampff.app</p>

    <h2>5. COOKIES</h2>
    <p>This site may use cookies to improve user experience and compile visit statistics. You can configure your browser to refuse cookies.</p>

    <h2>6. HYPERLINKS</h2>
    <p>This site may contain links to other sites. VOIGHT-KAMPFF has no control over these sites and disclaims all responsibility for their content.</p>

    <h2>7. LIMITATION OF LIABILITY</h2>
    <p>VOIGHT-KAMPFF endeavors to ensure the accuracy of information published on this site. However, it cannot guarantee the accuracy, precision or completeness of information made available.</p>
    <p>VOIGHT-KAMPFF disclaims all responsibility for any inaccuracy, imprecision or omission relating to information available on this site.</p>

    <h2>8. GOVERNING LAW</h2>
    <p>These legal notices are governed by French law. In case of dispute, and after failure of any attempt to find an amicable solution, French courts shall have sole jurisdiction.</p>

    <h2>9. CREDITS</h2>
    <p><strong>Design and development:</strong> VOIGHT-KAMPFF<br /><strong>Typography:</strong> Special Elite (Google Fonts)</p>
  </LegalPage>
);

const Support = () => (
  <LegalPage title="SUPPORT & CONTACT">
    <h2>NEED HELP?</h2>
    <p>Our team is here to help with all your questions about our applications.</p>

    <div style={{ background: '#f5f5f5', border: '2px solid #000', padding: '2rem', marginBottom: '3rem' }}>
      <h3 style={{ marginTop: 0, color: '#000' }}>CONTACT BY EMAIL</h3>
      <p style={{ fontSize: '1.3rem' }}><strong>support@voight-kampff.app</strong></p>
      <p>We typically respond within 48 business hours.</p>
    </div>

    <h2>FREQUENTLY ASKED QUESTIONS (FAQ)</h2>

    <h3>ACCOUNT & LOGIN</h3>
    <h4>How do I create an account?</h4>
    <p>Download the app from the App Store, then follow the registration instructions. You will need a valid email address.</p>
    <h4>I forgot my password</h4>
    <p>On the login screen, tap "Forgot password" and follow the instructions sent by email.</p>
    <h4>How do I delete my account?</h4>
    <p>You can delete your account in two ways:</p>
    <ul><li>In the app: Settings → Account → Delete my account</li><li>By email: Send a request to privacy@voight-kampff.app</li></ul>
    <p>Deletion will be effective within 30 days maximum. See our <Link to="/account-deletion" style={{color: '#000'}}>Account Deletion Page</Link>.</p>

    <h3>PURCHASES & SUBSCRIPTIONS</h3>
    <h4>How do I cancel a subscription?</h4>
    <p>Subscriptions are managed by Apple. To cancel:</p>
    <ol><li>Open your iPhone Settings</li><li>Tap your name at the top</li><li>Tap "Subscriptions"</li><li>Select the VOIGHT-KAMPFF subscription</li><li>Tap "Cancel Subscription"</li></ol>
    <h4>How do I request a refund?</h4>
    <p>Refunds are handled by Apple. Go to reportaproblem.apple.com with your Apple ID.</p>

    <h3>TECHNICAL ISSUES</h3>
    <h4>The app crashes or doesn't work properly</h4>
    <p>Try these solutions:</p>
    <ol><li>Close and relaunch the app</li><li>Check that your iOS is up to date</li><li>Uninstall and reinstall the app</li><li>Restart your device</li></ol>
    <p>If the problem persists, contact us with a detailed description.</p>
    <h4>How do I report a bug?</h4>
    <p>Send us an email at support@voight-kampff.app with:</p>
    <ul><li>The name of the affected app</li><li>Your device model and iOS version</li><li>A detailed description of the problem</li><li>Screenshots if possible</li></ul>

    <h3>PRIVACY & DATA</h3>
    <h4>How do I exercise my data rights?</h4>
    <p>Consult our <Link to="/privacy" style={{color: '#000'}}>Privacy Policy</Link> to learn about your rights. For any request: privacy@voight-kampff.app</p>
    <h4>Is my data secure?</h4>
    <p>Yes. We use encryption to protect your data and host it with Vercel.</p>

    <div style={{ background: '#f5f5f5', padding: '2rem', marginTop: '3rem', textAlign: 'center' }}>
      <p style={{ margin: 0, color: '#000' }}><strong>Didn't find the answer to your question?</strong><br /><br />Contact us: <strong>support@voight-kampff.app</strong></p>
    </div>

    <h2>APP-SPECIFIC SUPPORT PAGES</h2>
    <ul>
      {appsWithPages.map(app => (
        <li key={app.slug}><Link to={`/support/${app.slug}`} style={{color: '#000'}}>{app.name} Support</Link></li>
      ))}
    </ul>
  </LegalPage>
);

const AccountDeletion = () => (
  <LegalPage title="ACCOUNT DELETION">
    <h2>DELETE YOUR ACCOUNT</h2>
    <p>You have the right to request the deletion of your account and all associated personal data at any time.</p>

    <h3>Option 1: From within the app</h3>
    <ol><li>Open the app</li><li>Go to <strong>Settings</strong></li><li>Tap <strong>Account</strong></li><li>Tap <strong>Delete my account</strong></li><li>Confirm your choice</li></ol>

    <h3>Option 2: By email</h3>
    <p>Send an email to <strong>privacy@voight-kampff.app</strong> with:</p>
    <ul><li>Subject: "Account deletion"</li><li>The email address associated with your account</li><li>The name of the app(s) concerned</li></ul>

    <h2>WHAT HAPPENS WHEN YOU DELETE YOUR ACCOUNT?</h2>
    <ul>
      <li>Your account will be permanently deleted within <strong>30 days</strong></li>
      <li>All personal data associated with your account will be erased</li>
      <li>Your content and preferences will be permanently removed</li>
      <li>Active subscriptions should be cancelled separately via your Apple account settings</li>
    </ul>
    <p>Some data may be retained beyond 30 days if required by law (e.g., billing records for up to 10 years).</p>

    <h2>NEED HELP?</h2>
    <p>If you have any questions about account deletion, contact us at <strong>privacy@voight-kampff.app</strong></p>
  </LegalPage>
);

const AppPrivacy = ({ slug }) => {
  const app = appsWithPages.find(a => a.slug === slug);
  if (!app) return null;
  return (
    <main style={{ position: 'relative', zIndex: 10, minHeight: '100vh', padding: '8rem 2rem', maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '2rem', marginBottom: '0.5rem', color: '#000' }}>
        {app.name} — PRIVACY POLICY
      </h1>
      <p style={{ marginBottom: '3rem', opacity: 0.6 }}>{app.description}</p>
      <div className="legal-content">
        <p><strong>Last updated:</strong> February 2026</p>
        <p>This privacy policy applies specifically to the <strong>{app.name}</strong> application published by VOIGHT-KAMPFF. It complements our <Link to="/privacy" style={{color: '#000'}}>general Privacy Policy</Link>.</p>

        <h2>1. DATA CONTROLLER</h2>
        <p>VOIGHT-KAMPFF SARL<br />49 rue Charles Infroit<br />94500 Champigny-sur-Marne, France<br />SIRET: 823 547 526 00025<br />Email: privacy@voight-kampff.app</p>

        <h2>2. DATA COLLECTED BY {app.name}</h2>
        <h3>Data Linked to You</h3>
        <ul><li><strong>Contact Info</strong>: email address</li><li><strong>Identifiers</strong>: username, user ID</li><li><strong>Usage Data</strong>: product interaction, features used</li></ul>
        <h3>Data Not Linked to You</h3>
        <ul><li><strong>Diagnostics</strong>: crash data, performance data</li></ul>
        <h3>Data Used to Track You</h3>
        <p>None. {app.name} does not track you across apps or websites owned by other companies.</p>

        <h2>3. ADVERTISING & TRACKING</h2>
        <p>{app.name} does <strong>not</strong> use advertising tracking technologies. We do not collect or use the Apple Identifier for Advertisers (IDFA). We do not display third-party advertisements.</p>

        <h2>4. DATA SHARING</h2>
        <ul><li><strong>Hosting</strong>: Vercel Inc. (USA)</li><li><strong>Apple</strong>: for in-app purchases and distribution via the App Store</li></ul>
        <p>We never sell your personal data to third parties.</p>

        <h2>5. ACCOUNT DELETION</h2>
        <p>You can delete your account at any time:</p>
        <ul><li><strong>In the app</strong>: Settings → Account → Delete my account</li><li><strong>By email</strong>: privacy@voight-kampff.app</li><li><strong>Online</strong>: <Link to="/account-deletion" style={{color: '#000'}}>Account Deletion Page</Link></li></ul>

        <h2>6. YOUR RIGHTS</h2>
        <p>Under GDPR, you have rights of access, rectification, erasure, restriction, portability, and objection. Contact: <strong>privacy@voight-kampff.app</strong></p>

        <h2>7. FULL PRIVACY POLICY</h2>
        <p>For complete details on data processing, retention, security, and international transfers, please refer to our <Link to="/privacy" style={{color: '#000'}}>general Privacy Policy</Link>.</p>
      </div>
    </main>
  );
};

const AppSupport = ({ slug }) => {
  const app = appsWithPages.find(a => a.slug === slug);
  if (!app) return null;
  return (
    <main style={{ position: 'relative', zIndex: 10, minHeight: '100vh', padding: '8rem 2rem', maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ fontFamily: "'Special Elite', 'Courier New', monospace", fontSize: '2rem', marginBottom: '0.5rem', color: '#000' }}>
        {app.name} — SUPPORT
      </h1>
      <p style={{ marginBottom: '3rem', opacity: 0.6 }}>{app.description}</p>
      <div className="legal-content">
        <div style={{ background: '#f5f5f5', border: '2px solid #000', padding: '2rem', marginBottom: '3rem' }}>
          <h3 style={{ marginTop: 0, color: '#000' }}>CONTACT US</h3>
          <p style={{ fontSize: '1.3rem' }}><strong>support@voight-kampff.app</strong></p>
          <p>For any issue related to {app.name}, please include the app name in your email subject. We typically respond within 48 business hours.</p>
        </div>

        <h2>COMMON ISSUES</h2>
        <h3>The app crashes or doesn't work properly</h3>
        <ol><li>Close and relaunch {app.name}</li><li>Check that your iOS is up to date</li><li>Uninstall and reinstall the app from the App Store</li><li>Restart your device</li></ol>

        <h3>Account & Login</h3>
        <p>If you forgot your password, tap "Forgot password" on the login screen. To delete your account, visit our <Link to="/account-deletion" style={{color: '#000'}}>Account Deletion Page</Link>.</p>

        <h3>Subscriptions & Purchases</h3>
        <p>Subscriptions are managed by Apple. To cancel, go to iPhone Settings → your name → Subscriptions. For refunds, visit reportaproblem.apple.com.</p>

        <h3>Report a Bug</h3>
        <p>Email us at <strong>support@voight-kampff.app</strong> with:</p>
        <ul><li>App name: {app.name}</li><li>Your device model and iOS version</li><li>A description of the problem</li><li>Screenshots if possible</li></ul>

        <h3>Privacy & Data</h3>
        <p>Read the <Link to={`/privacy/${slug}`} style={{color: '#000'}}>{app.name} Privacy Policy</Link> or contact <strong>privacy@voight-kampff.app</strong>.</p>
      </div>
    </main>
  );
};

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/apps" element={<Layout><Apps /></Layout>} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/legal" element={<Layout><Legal /></Layout>} />
      <Route path="/support" element={<Layout><Support /></Layout>} />
      <Route path="/account-deletion" element={<Layout><AccountDeletion /></Layout>} />
      {appsWithPages.map(app => (
        <React.Fragment key={app.slug}>
          <Route path={`/privacy/${app.slug}`} element={<Layout><AppPrivacy slug={app.slug} /></Layout>} />
          <Route path={`/support/${app.slug}`} element={<Layout><AppSupport slug={app.slug} /></Layout>} />
        </React.Fragment>
      ))}
    </Routes>
  </BrowserRouter>
);

export default App;
